import type { TOC } from '@ember/component/template-only';
import type { Signature as ProviderSig } from 'parog-web/components/forc/provider';

export default <template>
  <div class='field'>
    <@form.Dropdown
      @labelName='Maladie sous-jacente'
      @propertyName='underlyingDisease'
      @translationKey='pathology.underlying-disease'
      @allowAdditions={{true}}
      as |dropdown|
    >
      <dropdown.Item
        @value="Fibrose pulmonaire d'origine toxique, médicamenteuse ou immunologique"
        @key='pulmonary_fibrosis'
      />
      <dropdown.Item @value='Mucoviscidose' @key='cystic_fibrosis' />
      <dropdown.Item
        @value='Maladies obstructives des voies aériennes'
        @key='obstructive_diseases'
      />
    </@form.Dropdown>
  </div>
</template> satisfies TOC<{
  Args: {
    form: ProviderSig['Blocks']['content'][0];
  };
}>;
